export default "__VITE_ASSET__BeeBbqG0__"